import styled from 'styled-components';

export const WishesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
